import React from 'react';
import { Box, Link, Text } from 'pcln-design-system';
const RealtimeToolTipInfo = ({
  isRealtime,
  handleShowRealTimeInfoModal
}) => {
  return React.createElement(Box, {
    px: 2,
    "data-testid": 'voice-mode-tooltip'
  }, React.createElement(Text, {
    fontWeight: 'bold'
  }, " ", isRealtime ? 'Penny Voice, Now Smarter' : 'Introducing Voice Chat'), React.createElement(Text, null, ' ', isRealtime ? React.createElement(Box, null, "Real-time travel help with advanced features.", ' ', React.createElement(Link, {
    onClick: function () {
      handleShowRealTimeInfoModal(true);
    }
  }, "Learn more"), ".") : 'Hands-free convenience. Tap the mic to start.'));
};
export default RealtimeToolTipInfo;